module.exports = __webpack_public_path__ + "static/media/calculator.831c9ad6.svg";